import { Hint, Label, Select } from '@lokalise/louis';

import type { Indentation } from '../../../../types';

type Option = { value: Indentation; label: string };

interface IndentationInputProps {
    value: Indentation;
    options: readonly Option[];
    onChange: (value: Indentation) => void;
}

const IndentationInput = ({ value, options, onChange }: IndentationInputProps) => (
    <Label
        id="IndentationInput"
        text={
            <>
                Indentation{' '}
                <Hint>
                    How many spaces should be used to indent your nested keys. Usually, 2 spaces represent one level of
                    indentation, but you may choose any value from one to eight. ALso, it is possible to choose Tab,
                    which means one indentation level equals to the ”Tab” key being pressed once, but this is not
                    generally recommended.
                </Hint>
            </>
        }
    >
        <Select
            aria-labelledby="IndentationInput"
            value={options.filter((item) => value === item.value)[0]}
            options={options}
            onChange={(val) => {
                if (val === null) {
                    return;
                }
                onChange(val.value);
            }}
        />
    </Label>
);

export default IndentationInput;
